import React, { useState, useEffect, ChangeEvent } from 'react';
import { Row, Col, Alert as Alrt } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { DetailItem } from '../../../../features/details';
import { updateAlert } from '../../../../services/api/alert';
import { getTransactionById, getPropertyInfo as getTransactionPropertyInfo } from '../../../../services/api/transaction';
import { ApiError, Alert } from '../../../../services/openapi';
import { useKeycloak } from '@react-keycloak/web'
import { PropertyInfo } from '../../../../services/openapi/models/PropertyInfo';
import { useNavigate } from "react-router-dom";
import { NotImplementedWarningModal } from '../../../../components/NotImplementedWarningModal';
import { setPendingSelectedId } from '../../../../hooks/pendingSelection';
import { popNavContext, pushNavContext } from '../../../../hooks/navContext';
import { useTranslation } from 'react-i18next';

const AlertDetails = () => {
    const [alert, setAlert] = useState<any>();
    const [showInputEle, setShowInputEle] = useState<boolean>(false);
    const [showModal, setShowModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState<string[]>([]);

    const { keycloak, initialized } = useKeycloak();
    const token = keycloak.token || '';

    const navigate = useNavigate();
    const { t } = useTranslation();
    
    const navigateBack = () => {
        popNavContext();
        navigate('/dashboard/lists/alerts');
    };

    const showError = (message: string) => {
        errorMsg.push(message);
        setErrorMsg([...errorMsg]);
        document.querySelector('.errorMsg')?.classList.remove("d-none");
    };

    // The transaction of the alert, with Back there returning to this alert
    const handleFieldClick = async (fieldName: string) => {
        if (fieldName !== 'alert.transactionId' || alert?.transactionId == null) {
            return;
        }

        try {
            const transaction: any = await getTransactionById(token, alert.transactionId);
            transaction.propertyNames = await getTransactionPropertyInfo(token);
            localStorage.setItem('Transaction', JSON.stringify(transaction));
        } catch (error) {
            console.log(error);
            showError(t("alert.transactionNotFound"));
            return;
        }

        pushNavContext({ from: 'details/alert', id: alert.id });
        navigate('/dashboard/details/transaction');
    };


    const setAlertData = (data: Alert) => {
        localStorage.setItem('Alert', JSON.stringify(data));
    }

    useEffect(() => {
        if (alert == null) {
            const json = localStorage.getItem('Alert') ?? "";
            const item = JSON.parse(json);

            setAlert(item);
        }
    }, [alert]);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        if (e.currentTarget.checkValidity()) {
            let alrt: Alert = alert;
            var update: Alert = {
                id: alrt.id,
                usernameConfirmation: keycloak.idTokenParsed?.preferred_username ?? '?'
            };
            setAlertData(alrt);
            updateAlert(token, alrt.id ?? 0, update).catch(err => console.log(err)).then((a : Alert) => {
                if (a !== undefined) {                    
                    setAlertData(a);
                    setAlert(a);
                }
                navigateBack();
            }).catch((error: ApiError) => {
                try {
                    document.querySelector('.errorMsg')?.classList.remove("d-none");
                    {/* k0 contains field name: e.g. LocationSelection, k1 contains array of error messages*/ }
                    Object.entries<Record<string, any>>(JSON.parse(error.body)["errors"]).forEach((k) => { k[1].forEach((msg: string) => { errorMsg.push(msg); setErrorMsg(errorMsg); }) });
                } catch (ex) {
                    errorMsg.push("Error handling response");
                    setErrorMsg(errorMsg);
                    document.querySelector('#refresh')?.classList.add("d-none");
                }
            });
            setShowInputEle(!showInputEle);
        }
    }    

    return (
        <>
            <div className="">
                <NotImplementedWarningModal
                    showModal={showModal}
                    handleClose={() => {
                        setShowModal(false);
                    }}
                />
            </div>
            <Row className="">
                <Col className="">
                    <Card className="rounded">
                        <Card.Body className="">
                            <form onSubmit={e => handleSubmit(e)}>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" className="">
                                        <h4 className="mb-2 qvend-title">{t("alarmdetails")}</h4>
                                    </Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" xs="12" className="mt-2">
                                        <div className="table-responsive-lg" style={{ overflowX: 'hidden' }}>
                                            <div>
                                                {alert && Object.entries<PropertyInfo>(alert).filter(([key, value]) => !(key === "poi" && value === null) && !(key === "vmcIdentifier" && value === null) && !(key === "transactionId" && value == null) && alert["propertyNames"][key] !== undefined).sort((a, b) => alert["propertyNames"][a[0]].sortOrderLevel - alert["propertyNames"][b[0]].sortOrderLevel).map(([key, value], index) => (
                                                    <DetailItem key={alert["propertyNames"][key].sortOrderLevel} propertyName={alert["propertyNames"][key].name} defaultValue={value ?? ""} rowColor={index % 2 ? "#cfd5ea" : "#e9ebf5"} editType={alert["propertyNames"][key].editType} pattern={alert["propertyNames"][key].valPattern} hideOnNull={alert["propertyNames"][key].hideOnNull}
                                                        handleDoubleClick={() => setShowInputEle(true)}
                                                        onFieldClick={handleFieldClick}
                                                        isClickable={key === "transactionId"}
                                                        handleChange={(e: ChangeEvent<HTMLInputElement>) => { alert[key] = (e.target.value); setAlert(alert); }} showInputEle={showInputEle} conditionToShowReferenceValue={alert[alert["propertyNames"][key].conditionToShowFieldName]} conditionToShowValue={alert["propertyNames"][key].conditionToShowValue}></DetailItem>
                                                ))}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="d-none errorMsg">
                                    <Col>
                                        {
                                            errorMsg.map((item, index) => {
                                                return <Alrt key={index} variant="warning" className="alert" role="alert">
                                                    <span>{item}</span>
                                                </Alrt>;
                                            })
                                        }
                                    </Col>
                                </Row>
                                <Row style={{ paddingTop: "3px" }}>
                                    <Col>
                                        <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px', backgroundColor: "red" }} onClick={() => { setPendingSelectedId("alerts", alert?.id); navigateBack(); }}>{t("button.back")}</button>
                                    </Col>
                                    <Col className="text-end">
                                        <button type="submit" className="btn btn-fixed-width" style={{ fontSize: '11px' }} disabled={ alert?.confirmationDateTime !== null }>{t("button.confirm")}</button>
                                    </Col>
                                </Row>
                            </form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default AlertDetails;